export default [
  // type =>
  // common : 공통 페이지,
  // admin : 관리자 페이지,
  // user: 사용자 페이지
  {
    path: '/403',
    meta: {
      public: true,
    },
    type: 'common',
    name: 'AccessDenied',
    component: () => import(`@/pages/Error.vue`),
  },
  {
    path: '/500',
    meta: {
      public: true,
    },
    type: 'common',
    name: 'ServerError',
    component: () => import(`@/pages/Error.vue`),
  },
  // {
  //   path: '/join',
  //   meta: {
  //     public: true,
  //   },
  //   name: 'Join',
  //   component: () => import(`@/pages/Join.vue`),
  // },
  // {
  //   path: '/mJoin',
  //   meta: {
  //     webexMeeting: true,
  //   },
  //   component: () => import('@/pages/sections/MobileJoin.vue'),
  // },
  {
    path: '/login',
    meta: {
      public: true,
    },
    type: 'common',
    name: 'Login',
    component: () => import(`@/pages/Login.vue`),
  },
  {
    path: '/tbLogin',
    meta: {
      public: true,
    },
    type: 'common',
    name: 'tbLogin',
    component: () => import(`@/pages/TbLogin.vue`),
  },
  {
    path: '/tempLogin',
    meta: {
      public: true,
    },
    type: 'common',
    name: 'TempLogin',
    component: () => import(`@/pages/TempLogin.vue`),
  },
  // {
  //   path: '/faq',
  //   meta: {
  //     webexMeeting: false,
  //   },
  //   name: 'FAQ',
  //   component: () => import('@/pages/FAQ.vue'),
  // },
  // {
  //   path: '/qna',
  //   meta: {
  //     webexMeeting: false,
  //   },
  //   name: 'QNA',
  //   component: () => import('@/pages/QNA.vue'),
  // },
  // {
  //   path: '/survey',
  //   meta: {
  //     webexAdminMeeting: true,
  //   },
  //   type: 'user',
  //   name: 'surveyT',
  //   component: () => import('@/pages/SURVEY.vue'),
  // },
  // {
  //   path: '/loginPW',
  //   meta: {
  //     public: true,
  //   },
  //   name: 'LoginPW',
  //   component: () => import(`@/pages/LoginPW.vue`),
  //   props: (route) => ({
  //     email: route.query.email,
  //   }),
  // },

  {
    path: '/',
    meta: {
      webexMeeting: true,
    },
    type: 'common',
    component: () => import('@/pages/home/Index.vue'),
  },
  {
    path: '/betaLogin',
    meta: {
      webexMeeting: true,
    },
    type: 'common',
    component: () => import('@/pages/sections/Home.vue'),
  },
  {
    path: '/home',
    meta: {
      webexMeeting: true,
    },
    type: 'common',
    name: 'Home',
    component: () => import('@/pages/home/Index.vue'),
  },
  {
    path: '/ssoLogin',
    meta: {
      webexMeeting: true,
    },
    type: 'common',
    name: 'SsoLogin',
    component: () => import('@/pages/SsoLogin.vue'),
  },
  {
    path: '/checkAgent',
    meta: {
      webexMeeting: true,
    },
    type: 'common',
    name: 'checkAgent',
    component: () => import('@/pages/CheckAgent.vue'),
  },
  {
    // 개발 테스트용 페이지지
    path: '/ksdTest',
    meta: {
      webexMeeting: false,
    },
    type: 'common',
    name: 'ksdTest',
    component: () => import('@/pages/KsdTest.vue'),
  },

  // {
  //   path: '/krxPopupSso',
  //   meta: {
  //     webexMeeting: true,
  //   },
  //   name: 'KrxPopupSso',
  //   component: () => import('@/pages/KrxPopupSso.vue'),
  // },
  // {
  //   path: '/krxFlowSso',
  //   meta: {
  //     webexMeeting: true,
  //   },
  //   name: 'KrxFlowSso',
  //   component: () => import('@/pages/KrxFlowSso.vue'),
  // },
  // {
  //   path: '/profile',
  //   meta: {
  //     webexMeeting: false,
  //   },
  //   name: 'Profile',
  //   component: () => import('@/pages/sections/Profile.vue'),
  // },
  // {
  //   path: '/personalAddress',
  //   meta: {
  //     webexMeeting: false,
  //   },
  //   name: 'PersonalAddress',
  //   component: () => import('@/pages/sections/PersonalAddress.vue'),
  // },
  // {
  //   path: '/hero',
  //   meta: {
  //     webexMeeting: false,
  //   },
  //   name: 'Hero',
  //   component: () => import('@/pages/sections/Hero.vue'),
  // },
  {
    path: '/attendMeeting',
    meta: {
      public: true,
    },
    type: 'user',
    name: 'AttendMeeting',
    component: () => import('@/pages/sections/AttendMeeting.vue'),
  },
  // {
  //   path: '/dmzAttendMeeting',
  //   meta: {
  //     public: true,
  //   },
  //   name: 'DmzAttendMeeting',
  //   component: () => import('@/pages/sections/DmzAttendMeeting.vue'),
  // },
  // {
  //   path: '/webRtcMeeting',
  //   meta: {
  //     public: true,
  //   },
  //   name: 'WebRtcMeeting',
  //   component: () => import('@/pages/sections/WebRtcMeeting.vue'),
  // },
  {
    path: '/meeting',
    meta: {
      webexMeeting: false,
    },
    type: 'user',
    name: 'Meeting',
    component: () => import('@/pages/Meeting.vue'),
  },
  {
    path: '/sMeeting',
    meta: {
      frame: true,
    },
    type: 'user',
    name: 'sMeeting',
    component: () => import('@/pages/Kmeeting.vue'),
  },
  {
    path: '/sMeetingFrame',
    meta: {
      frameBody: true,
    },
    type: 'user',
    name: 'sMeetingFrame',
    component: () => import('@/pages/KmeetingFrame.vue'),
  },
  {
    path: '/additionalInvitation',
    meta: {
      webexMeeting: true,
    },
    type: 'user',
    name: 'additionalInvitation',
    component: () => import('@/pages/additionalInvitation.vue'),
  },
  {
    path: '/ssoSuccess/:user',
    meta: { public: true },
    type: 'common',
    name: 'SSOSuccess',
    component: () => import(`@/pages/SSOSuccess.vue`),
  },
  {
    path: '/ssoSuccess',
    meta: { public: true },
    type: 'common',
    name: 'SSOSuccessQuery',
    component: () => import(`@/pages/SSOSuccess.vue`),
  },

  {
    path: '/kSsoSuccess',
    meta: { public: true },
    type: 'common',
    name: 'kSsoSuccess',
    component: () => import(`@/pages/KSSOSuccess.vue`),
  },

  // {
  //   path: '/regNotice',
  //   meta: { public: true },
  //   name: 'regNotice',
  //   component: () => import(`@/pages/RegNotice.vue`),
  // },
  // {
  //   path: '/notice',
  //   meta: { public: true },
  //   name: 'notice',
  //   component: () => import(`@/pages/Notice.vue`),
  // },
  // {
  //   path: '/detailNotice',
  //   meta: { public: true },
  //   name: 'detailNotice',
  //   component: () => import(`@/pages/DetailNotice.vue`),
  // },

  /* 관리자 화면 PATH */
  {
    path: '/dashboard',
    meta: {
      webexAdminMeeting: true,
    },
    type: 'admin',
    name: 'Dashboard',
    component: () => import('@/pages/admin/sections/Dashboard.vue'),
  },
  {
    path: '/statistics',
    meta: {
      webexAdminMeeting: true,
    },
    type: 'admin',
    name: 'Statistics',
    component: () => import('@/pages/admin/sections/Statistics.vue'),
  },
  {
    path: '/manageMeetingRoom',
    meta: {
      webexAdminMeeting: true,
    },
    type: 'admin',
    name: 'ManageMeetingRoom',
    component: () => import('@/pages/admin/sections/ManageMeetingRoom.vue'),
  },
  {
    path: '/manageVideoMeetingRoom',
    meta: {
      webexAdminMeeting: true,
    },
    type: 'admin',
    name: 'ManageVideoMeetingRoom',
    component: () =>
      import('@/pages/admin/sections/ManageVideoMeetingRoom.vue'),
  },
  {
    path: '/manageUsers',
    meta: {
      webexAdminMeeting: true,
    },
    type: 'admin',
    name: 'ManageUsers',
    component: () => import('@/pages/admin/sections/ManageUsers.vue'),
  },
  {
    path: '/manageHistory',
    meta: {
      webexAdminMeeting: true,
    },
    type: 'admin',
    name: 'ManageHistory',
    component: () => import('@/pages/admin/sections/ManageHistory.vue'),
  },
  {
    path: '/manageSystem',
    meta: {
      webexAdminMeeting: true,
    },
    type: 'admin',
    name: 'ManageSystem',
    component: () => import('@/pages/admin/sections/ManageSystem.vue'),
  },
  // 관리자
  // {
  //   path: '/siteManage',
  //   meta: {
  //     webexAdminMeeting: true,
  //   },
  //   name: 'SiteManage',
  //   component: () => import('@/pages/admin/sections/SiteManage.vue'),
  // },
  {
    path: '/reserveDialog',
    meta: {
      webexMeeting: true,
    },
    type: 'user',
    name: 'reserveDialog',
    component: () => import(`@/pages/ReserveDialog.vue`),
  },
  // {
  //   path: '/messengerDialog',
  //   meta: {
  //     webexMeeting: true,
  //   },
  //   name: 'messengerDialog',
  //   component: () => import(`@/pages/MessengerDialog.vue`),
  // },
  // {
  //   path: '/gaonReserveDialog',
  //   meta: { public: true },
  //   name: 'gaonReserveDialog',
  //   component: () => import(`@/pages/GaonReserveDialog.vue`),
  // },
  // {
  //   path: '/flowReserveDialog',
  //   meta: {
  //     webexMeeting: true,
  //   },
  //   name: 'flowReserveDialog',
  //   component: () => import(`@/pages/FlowReserveDialog.vue`),
  // },
  // {
  //   path: '/checkEditJoinDialog',
  //   meta: { public: true },
  //   name: 'checkEditJoinDialog',
  //   component: () => import(`@/pages/CheckEditJoinDialog.vue`),
  // },
  // {
  //   path: '/checkJoinDialog',
  //   meta: { public: true },
  //   name: 'checkJoinDialog',
  //   component: () => import(`@/pages/CheckJoinDialog.vue`),
  // },
  // {
  //   path: "/checkJoiner",
  //   meta: {
  //     webexMeeting: true,
  //   },
  //   name: "checkJoiner",
  //   component: () => import(`@/pages/CheckJoiner.vue`),
  // },
  // {
  //   path: '/JoinMeetingDialog',
  //   meta: { public: true },
  //   name: 'joinMeetingDialog',
  //   component: () => import(`@/components/ksd/popup/JoinMeetingDialog.vue`),
  // },
  {
    path: '/kMeetingTb',
    meta: { public: true },
    name: 'kMeetingTb',
    type: 'user',
    component: () => import(`@/components/krx/KmeetingTb.vue`),
  },
  // {
  //   path: '/kMeetingMb',
  //   meta: { public: true },
  //   name: 'kMeetingMb',
  //   type: 'admin',
  //   component: () => import(`@/components/krx/KmeetingMb.vue`),
  // },
  {
    path: '/ksdSlo',
    meta: { public: true },
    name: 'ksdSlo',
    type: 'common',
    component: () => import('@/pages/KsdSlo.vue'),
  },
];



// WEBPACK FOOTER //
// ./src/router/paths.js